<section
  class="relative flex h-full w-full shrink-0 flex-col items-center justify-center"
  (waIntersectionObservee)="onIntersectionDetected($event)">
  @if (isImageLoaded()) {
    <img
      draggable="false"
      class="h-full w-full"
      [attr.data-rotation]="0"
      [src]="getImageSrc()"
      (load)="onImageLoaded(image)"
      #image />
  } @else {
    <p-progress-spinner class="flex aspect-[0.7/1] items-center justify-center" />
  }
</section>
